export default __webpack_public_path__ + "static/media/mail.ac863c4a.png";